import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_PARENT_UI_STATE } from "./consts";
import parentUiReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_PARENT_UI_STATE, builder => {
  builder.register(PATH_PARENT_UI_STATE, parentUiReducer);
});

export { PATH_PARENT_UI_STATE };

// actions
export {
  updateStartTime,
  updateEndTime,
  updateSelectedTimePeriod
} from "../features/dropdowns/state";

export { setAssignmentsFilter } from "../features/assignmentsFilter/state";

// models
export { default as ParentUiState } from "./models/ParentUiState";

// selectors
export {
  getSelectedChildInitialised,
  getChildUserId,
  getStartTime,
  getEndTime,
  isCustomPeriod,
  getSelectedAssignmentsFilter
} from "./selectors";
